import Chart from 'chart.js/auto';
import {getLocaleFromBrowser} from '../../utility/locale';
import {getChartOptions} from './chart-options';

export class ChartCard {
	constructor($container, metricsType, data) {
		this.metricsType = metricsType;
		this.data = data;

		// get dom elements
		this.$container = $container;
		this.$labelLineChart = $container.querySelector('.c-toggle__label--line-chart');
		this.$radioLineChart = $container.querySelector('.c-toggle__input--line');
		this.$labelBarChart = $container.querySelector('.c-toggle__label--bar-chart');
		this.$radioBarChart = $container.querySelector('.c-toggle__input--bar');
		this.$chartWrapper = $container.querySelector('.wrapper-bar-chart');
	}

	init() {
		// set click handlers
		this.$radioLineChart.addEventListener('click', this.showLineChart.bind(this));
		this.$radioBarChart.addEventListener('click', this.showBarChart.bind(this));

		// bar chart is the default chart
		this.showBarChart();
	}

	showBarChart() {
		this.isBarChart = true;
		this.drawChart(this.data, this.metricsType, 'bar');
		this.$labelBarChart.classList.add('js-toggle-label-selected');
		this.$labelLineChart.classList.remove('js-toggle-label-selected');
	}

	showLineChart() {
		this.isBarChart = false;
		this.drawChart(this.data, this.metricsType, 'line');
		this.$labelBarChart.classList.remove('js-toggle-label-selected');
		this.$labelLineChart.classList.add('js-toggle-label-selected');
	}

	drawChart(data, metricsType, chartType) {
		Chart.defaults.locale = getLocaleFromBrowser(); // For number formatting

		const valuesForGivenMetricType = data[metricsType];
		const allAvailableYears = data.years;
		const chartOptions = getChartOptions(allAvailableYears, valuesForGivenMetricType, metricsType, chartType);

		const existingChart = Chart.getChart(this.$chartWrapper);
		if (existingChart) {
			existingChart.destroy();
		}

		const chartSvg = new Chart(this.$chartWrapper, chartOptions);
		return chartSvg;
	}
}
